import { Card, Skeleton, Group } from '@mantine/core';

interface SecurityCardSkeletonProps {
  height?: number;
}

/**
 * Skeleton loading component for security dashboard cards
 * @param height - Optional height for the skeleton card
 */
export function SecurityCardSkeleton({ height = 120 }: SecurityCardSkeletonProps): JSX.Element {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder style={{ height }}>
      <Group justify="space-between" mb="xs">
        <Skeleton height={16} width="60%" />
        <Skeleton height={20} width={20} radius="50%" />
      </Group>
      <Skeleton height={32} width="40%" mb="xs" />
      <Skeleton height={12} width="80%" />
    </Card>
  );
}
